"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Клик в нажатие/отжатие "Разместить на зарплата.ру" (событие из analytics_request) */
const vacancyCreateZpCrosspostChange = ({ selectedType, previousValue, newValue, draftId, vacancyId, ...analyticsParams } = {}) => analytics_js_1.default.sendHHEvent("VACANCY_CREATE_ZP_CROSSPOST_CHANGE", { selectedType, previousValue, newValue, draftId, vacancyId, ...analyticsParams });
exports.default = vacancyCreateZpCrosspostChange;
